module.exports = __webpack_public_path__ + "media/images/emblems/Hellsau-coat_of_arms-b1a9cc5dee2e26e5f3c2cc748b7c6af1.svg";